var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"guide"},[_c('GuideTours'),_c('GuideHotels'),_c('GuideRestaurants'),_c('GuideFood'),_c('GuideApp')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }